// import jCaptcha from 'js-captcha';
import { jCaptcha } from "@/public/jCaptcha";
// optionally, set maximum number of captcha validation on event:
// const getJcapthaEle = document.getElementsByClassName('jCaptchaWrapper');

const captchaValidation = (id) => {
    // console.log(id);
    const maxNumberOfTries = 5;

    // captcha initial setup

    let myCaptcha = new jCaptcha({
        el: '#' + id,
        requiredValue: '=',
        canvasClass: id,
        canvasStyle: {
            // properties for captcha stylings
            width: 60,
            height: 16,
            textBaseline: "top",
            font: "19px Arial",
            textAlign: "left",
            fillStyle: "#000",
        },

        // set callback function
        callback: function (
            response,
            $captchaInputElement,
            numberOfTries,
        ) {
            // console.log($captchaInputElement);

            // let $currentCaptchaInput = event.target.querySelector('.jCaptcha');

            let captchaInputElementParent = $captchaInputElement.closest('.jCaptchaWrapper');
            let warningText = captchaInputElementParent.querySelector('.warningInfo');
            let symbolIcon = captchaInputElementParent.querySelector('.symbolIcon');
            if (maxNumberOfTries === numberOfTries) {
                // maximum attempts reached, so do something
                // e.g. disable the form:
                // document
                //     .querySelector("form")
                //     .removeEventListener("submit", formSubmit);

                $captchaInputElement.classList.add("disabled");
                // $captchaInputElement.placeholder =
                //     "Maximum attempts reached!";
                $captchaInputElement.setAttribute("disabled", "true");
                document
                    .querySelector("button")
                    .setAttribute("disabled", "true");

                return;
            }
            console.log('response:' + response);
            if (response == "success") {
                $captchaInputElement.classList.remove("error");
                $captchaInputElement.classList.add("success");

                if (warningText) {
                    warningText.classList.add('text-info')
                    warningText.classList.remove('text-danger');
                    warningText.innerHTML = '';
                }
                if (symbolIcon) {
                    symbolIcon.classList.add('text-info')
                    symbolIcon.classList.remove('text-danger');
                    symbolIcon.innerHTML = '✓';
                }
                // $captchaInputElement.placeholder = "Submit successful!";

                // now continue with form submit
            }

            if (response == "error") {
                $captchaInputElement.classList.remove("success");
                $captchaInputElement.classList.add("error");
                if (warningText) {
                    warningText.classList.add('text-danger');
                    warningText.classList.remove('text-info')
                    warningText.innerHTML = `Whoops! Your request didn't go through. Please solve the equation and try again!`;
                }
                if (symbolIcon) {
                    symbolIcon.classList.add('text-danger');
                    symbolIcon.classList.remove('text-info')
                    symbolIcon.innerHTML = `✗`;
                }
                // $captchaInputElement.placeholder = "Please try again!";
            }
        },
    });

    return myCaptcha;
}




const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}



const getTopDomain = () => {
    let cross_domain = '';
    if (location.hostname.indexOf('ooma.com') !== -1) {
        cross_domain = '.ooma.com';
    } else if (location.hostname.indexOf('ooma.ca') !== -1) {
        cross_domain = '.ooma.ca';
    }
    else if (location.hostname.indexOf('us-site') !== -1) {
        cross_domain = '.us-site';
    }
    return cross_domain;
}


const setCookie = (name, value, days) => {

    if (days === undefined) {
        days = 60;
    }

    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString() + ';domain=' + getTopDomain();
}

const asyncJS = (src) => {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', function () {
            resolve();
        });
        script.addEventListener('error', function (e) {
            reject(e);
        });
        document.body.appendChild(script);
    })
};

const getDomain = () => {
    const currentDomain = window.location.hostname;
    let myDomain = 'us';
    if (currentDomain.indexOf('.ca') > -1) {
        myDomain = 'ca';

    }

    return myDomain;
}





const getUrlVars = () => {

    let e = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (o, t, c) {
        e[t.toLowerCase()] = c;

    });
    return e;
};


const subSourcePopulation = (el, attr, val) => {

    if (el.hasAttribute(attr)) {
        let existingSubSource = el.getAttribute(attr).trim();
        if (existingSubSource.length === 0) {
            el.setAttribute(attr, val);
        }
        else {
            el.setAttribute(attr, val + '--' + existingSubSource);
        }
    }
    else {
        el.setAttribute(attr, val)
    }

}

const attributeValidation = (attrVal) => {
    if (attrVal !== null && attrVal.length > -1) {

        if (attrVal.indexOf('/') > -1) {
            const lastSlashIndex = attrVal.lastIndexOf('/') + 1;
            attrVal = attrVal.substring(lastSlashIndex);
        }
        return ' ' + attrVal

    }
    else {
        attrVal = '';

    }
    return ' ' + attrVal
}


const isScriptAdded = (src) => {
    return Boolean(document.querySelector('script[src="' + src + '"]'));
}


const sentEmail = (type, data, url) => {

    $.ajax({
        type: type,
        url: url,
        data: data,
        success: function (data) {
            console.log(data);
        },
        error: function (xhr, status, error) {
            console.log(xhr, status, error);
            console.log('Email delivery fail.');
        }

    })
}



const sentEmailWithFetch = (type, data, url) => {
    // try {

    // } catch (console) {
    //     console.log('There was an error', erro);
    // }
    console.log('check fetch data type')
    console.log(typeof data);

    const formData = new FormData();
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, data[key]);
        }
    }
    console.log(typeof formData);
    console.log('formData: ', formData);
    fetch(url, {
        method: type,
        // headers: {
        //     "Content-Type": "application/json"
        // },
        body: data
    })
        .then(response => {
            console.log('response: ', response)
        })
        .catch(error => {
            // Handle any errors that occurred during the request
            console.error(error);
        });
}



const sendLeadToRep = (isSendEmail, userData) => {
    let serializeEmailData = isSendEmail.split("|");
    let emailData = {
        'sendEmail': (function () {
            let emailAddress = serializeEmailData[0].trim();
            if (!emailAddress.includes('#') && !emailAddress.includes('@')) {
                emailAddress = emailAddress + '@ooma.com';
            }
            if (emailAddress.includes('#')) {
                emailAddress = emailAddress.replace('#', '@');
            }
            return emailAddress;
        })(),
        'emailObject': serializeEmailData[1].trim(),
        'pageUrl': getCookie('XYZpage_url')
    }

    let data = $.extend({}, userData, emailData);
    sentEmail('POST', data, '/wp-content/plugins/wp-ooma-mkto-api/server-side/send-lead-to-email/index.php');
    // sentEmailWithFetch('POST', data, '/wp-content/plugins/wp-ooma-mkto-api/server-side/send-lead-to-email/index.php');
}

// const getKickboxResponse_01 = (type, data, url, callback) => {
//     $.ajax({
//         type: type,
//         url: url,
//         data: data,
//         async: false,
//         success: function (response) {
//             // console.log(typeof response);
//             response = JSON.parse(response);
//             callback(response);
//         },
//         error: function (xhr, status, error) {
//             console.log(xhr, status, error);
//         }

//     })

// }




const getKickboxResponse = (type, data, url, delay, callback) => {

    const startTime = new Date().getTime();
    $.ajax({
        type: type,
        url: url,
        data: data,
        async: false, // make synchronous AJAX call
        success: function (response) {
            const endTime = new Date().getTime();
            const responseTime = endTime - startTime;
            let kickboxResponse = {};
            response = JSON.parse(response);

            if (responseTime < delay) {
                kickboxResponse['kickboxStatus'] = response['result'];
                kickboxResponse['kickboxStatusReason'] = response['reason'];
                kickboxResponse['kickboxSendex'] = response['sendex'];
                callback(kickboxResponse);

            } else {
                callback(); // execute callback if response is delayed by more than delay time
            }
        },
        error: function (error) {
            console.error(error);
        }
    });
}


const getMelissaResponse = (type, data, url, delay, callback) => {

    const startTime = new Date().getTime();
    $.ajax({
        type: type,
        url: url,
        data: data,
        async: false, // make synchronous AJAX call
        success: function (response) {
            const endTime = new Date().getTime();
            const responseTime = endTime - startTime;
            let melissaResponse = {};
            response = JSON.parse(response);
            console.log('response');
            if (responseTime < delay) {
                // melissaResponse['kickboxStatus'] = response['result'];
                // melissaResponse['kickboxStatusReason'] = response['reason'];
                // melissaResponse['kickboxSendex'] = response['sendex'];
                // callback(melissaResponse);

            } else {
                callback(); // execute callback if response is delayed by more than delay time
            }
        },
        error: function (error) {
            console.error(error);
        }
    });
}


const apolloCallAPI = (type, data, url, callback) => {
    console.log('call apollo', data);
    $.ajax({
        type: type,
        url: url,
        data: data,
        async: false,
        success: function (response) {
            // console.log(typeof response);
            console.log('apollo response: ' + response);
            // response = JSON.parse(response);
            // callback(response);
        },
        error: function (xhr, status, error) {
            console.log(xhr, status, error);
        }

    })

}


const checkGDPR = () => {
    $('form input[name="GDPR_Opt_in__c"]').each(function () {
        $(this).on(
            'click', function () {
                console.log($(this).is(':checked'));
                if ($(this).is(':checked')) {
                    $(this).prop('value', 'true');
                    let today = new Date();
                    let dd = String(today.getDate()).padStart(2, '0');
                    let mm = String((today.getMonth() + 1)).padStart(2, '0');
                    let yyyy = today.getFullYear();
                    let hh = today.getHours();
                    let min = today.getMinutes();
                    let getDate = dd + '-' + mm + '-' + yyyy + '-' + hh + '-' + min;
                    $(this).siblings('input[name="GDPR_Opt_in_Date__c"]').val(getDate);
                }
                else {
                    $(this).prop('value', 'false');
                    $(this).siblings('input[name="GDPR_Opt_in_Date__c"]').val('');
                }
            }
        )
    })
}




const deviceValidate = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const getBrowser = () => {

    var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    if (ua.match(/FBAN|FBAV/i)) {
        return 'Messenger';
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');

}


export {
    getCookie,
    setCookie,
    subSourcePopulation,
    attributeValidation,
    asyncJS,
    getDomain,
    getUrlVars,
    captchaValidation,
    isScriptAdded,
    sentEmail,
    sentEmailWithFetch,
    sendLeadToRep,
    getKickboxResponse,
    checkGDPR,
    getMelissaResponse,
    deviceValidate,
    getBrowser,
    apolloCallAPI



}